module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 35 35"
    }
  }, [_c('defs'), _c('g', {
    attrs: {
      "id": "Слой_2",
      "data-name": "Слой 2"
    }
  }, [_c('g', {
    attrs: {
      "id": "Слой_1-2",
      "data-name": "Слой 1"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M14.2,11c-3.79,0-7.58,0-11.37,0-.52,0-.66.12-.66.65q0,7,0,14c0,.6.2.72.75.71,3.92,0,7.85,0,11.78,0,.48,0,.68.11.62.61a6.09,6.09,0,0,0,0,1.13c0,.38-.13.45-.48.45H2.35A2.29,2.29,0,0,1,0,26.09Q0,16.42,0,6.74A2.49,2.49,0,0,1,3,4.37c.25.06.23.22.24.4a9.39,9.39,0,0,0,0,1.06A2.18,2.18,0,0,0,5.59,7.66a2.2,2.2,0,0,0,2.05-2c0-.4-.18-.94.12-1.19S8.59,4.38,9,4.38c3.69,0,7.38,0,11.07,0,.6,0,.72.17.7.72a2.24,2.24,0,0,0,1.62,2.5,2.18,2.18,0,0,0,2.74-2c0-.07,0-.15,0-.23,0-1.13,0-1.13,1.15-1a2.34,2.34,0,0,1,2.12,2.26c0,2.76,0,5.52,0,8.28,0,.33-.14.39-.43.41-1.78.09-1.78.1-1.78-1.7,0-.71,0-1.43,0-2.13,0-.46-.15-.56-.58-.56C21.86,11,18,11,14.2,11Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M35,26.29a8.75,8.75,0,1,1-8.48-8.79A8.74,8.74,0,0,1,35,26.29ZM26.25,32.8a6.56,6.56,0,0,0,6.57-6.53,6.57,6.57,0,0,0-13.13,0A6.56,6.56,0,0,0,26.25,32.8Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M6.51,17.49c-.6,0-1.21,0-1.82,0-.26,0-.35-.09-.35-.33,0-1.24,0-2.48,0-3.72,0-.27.12-.33.36-.33q1.83,0,3.66,0c.25,0,.37.07.36.33,0,1.22,0,2.44,0,3.65,0,.34-.14.44-.47.43-.59,0-1.18,0-1.77,0Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M15.31,15.26c0,.6,0,1.21,0,1.82,0,.3-.05.43-.38.42-1.22,0-2.44,0-3.66,0-.3,0-.37-.14-.36-.4,0-1.21,0-2.41,0-3.61,0-.29.12-.37.39-.37,1.2,0,2.4,0,3.61,0,.32,0,.4.13.39.42,0,.57,0,1.14,0,1.72Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M19.66,17.5c-.6,0-1.19,0-1.78,0-.27,0-.38-.07-.38-.36q0-1.83,0-3.66c0-.28.1-.37.38-.37,1.2,0,2.41,0,3.61,0,.27,0,.39.08.39.37,0,1.22,0,2.44,0,3.66,0,.31-.13.36-.39.35-.61,0-1.22,0-1.82,0Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M4.37,21.82c0-.61,0-1.22,0-1.83,0-.24,0-.3.28-.3,1.26,0,2.52,0,3.78-.05.28,0,.36.13.36.41,0,1.16,0,2.32,0,3.49,0,.35-.06.53-.48.52-1.14,0-2.29,0-3.43,0-.37,0-.49-.1-.48-.47,0-.59,0-1.18,0-1.77Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M10.92,21.8c0-.57,0-1.14,0-1.71,0-.3.05-.45.37-.45l3.65.05c.27,0,.38.06.38.36q0,1.83,0,3.66c0,.25-.09.35-.34.35H11.32c-.33,0-.4-.15-.39-.43,0-.61,0-1.22,0-1.83Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M24.07,3.35c0,.67,0,1.34,0,2A1.12,1.12,0,0,1,23,6.57a1.1,1.1,0,0,1-1.09-1.16q0-2.13,0-4.26a1.1,1.1,0,1,1,2.19,0C24.08,1.89,24.07,2.62,24.07,3.35Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M6.56,3.25c0,.71,0,1.42,0,2.13a1.11,1.11,0,0,1-1,1.19A1.09,1.09,0,0,1,4.38,5.39c0-1.4,0-2.8,0-4.2a1.08,1.08,0,1,1,2.16,0C6.56,1.87,6.56,2.56,6.56,3.25Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M27.32,28.43c-.71,0-1.42,0-2.13,0a1,1,0,0,1-1.11-1.11q0-2.16,0-4.32a1.08,1.08,0,1,1,2.16,0c0,.93,0,1.86,0,2.78,0,.36.11.49.47.48.89,0,1.78,0,2.67,0s1.25.43,1.24,1.1-.47,1.06-1.23,1.07-1.38,0-2.07,0Z"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94c9062e","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIconNew/templates/icons/calendar.vue
// module id = bf23339b52905767af90
// module chunks = 89